import { cn } from '@/lib/utils'

interface ProcessStepProps {
  /** Step number (1, 2, 3, etc.) */
  number: number
  /** Step title */
  title: string
  /** Step description */
  description: string
  /** Whether this is the last step (no connector line) */
  isLast?: boolean
  /** Additional classes */
  className?: string
}

export function ProcessStep({ number, title, description, isLast = false, className }: ProcessStepProps) {
  return (
    <div className={cn('relative flex gap-4 md:gap-6', className)}>
      {/* Number circle and connector line */}
      <div className="flex flex-col items-center">
        <div className="gradient-gold text-primary-foreground flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-lg font-bold">
          {number}
        </div>
        {!isLast && <div className="from-primary/50 h-full min-h-[60px] w-px bg-gradient-to-b to-transparent" />}
      </div>

      {/* Content */}
      <div className="pb-8">
        <h3 className="text-foreground mb-2 text-xl font-semibold">{title}</h3>
        <p className="text-muted-foreground leading-relaxed">{description}</p>
      </div>
    </div>
  )
}

interface ProcessStepsProps {
  steps: Array<{
    title: string
    description: string
  }>
  className?: string
}

export function ProcessSteps({ steps, className }: ProcessStepsProps) {
  return (
    <div className={className}>
      {steps.map((step, index) => (
        <ProcessStep
          key={index}
          number={index + 1}
          title={step.title}
          description={step.description}
          isLast={index === steps.length - 1}
        />
      ))}
    </div>
  )
}
